module.exports = __webpack_public_path__ + "img/1547293027.f57a5793.jpg";